import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import useTranslation from '../../../hooks/useTranslation';

import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';

export interface WithTitleProps {}

/**
 * @component
 * @visibleName withTitle
 */
export default function withTitle(title: string) {
  return (WrappedComponent: FC<WithTitleProps>) => {
    const WithTitle = (props: WithTitleProps) => {
      const { t } = useTranslation();
      return (
        <>
          <Helmet>
            <title>{t(title)}</title>
          </Helmet>
          <WrappedComponent {...props} />
        </>
      );
    };

    WithTitle.displayName = getWrappedDisplayName('WithTitle', WrappedComponent);

    return WithTitle;
  };
}
